import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const SupportedFileTypesBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background-color: ${COLORS.fillSubtle};
  border-radius: ${RADII.card};
`
